import type { RibbonControlProps } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import { type MailRibbonControlId, type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import type { RibbonControlId } from 'owa-ribbon-ids';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { logUsage } from 'owa-analytics';
import { debugErrorThatWillShowErrorPopupOnly } from 'owa-trace';
import { getRibbonMailboxInfo } from 'owa-mail-ribbon-utils/lib/getRibbonMailboxInfo';
import { getFolderPaneControl } from '../../sharedControls/readSharedControlDefinitions';

export const getSLRFolderTabControlDefinition: (
    controlId: RibbonControlId,
    _tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
) => RibbonControlProps | undefined = owaComputedFn(function getSLRFolderTabControlDefinition(
    controlId: RibbonControlId,
    _tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
): RibbonControlProps | undefined {
    switch (controlId) {
        case 647:
            return getFolderPaneControl(true /* isSLR */, 17, props);
        default:
            const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);

            debugErrorThatWillShowErrorPopupOnly(
                'getSLRFolderTabControlDefinition UnknownControl: ' + controlId
            );

            logUsage('SLRFolderTabControlDefinitionUnknownControl', mailboxInfo, {
                controlId,
                stack: new Error('SLRFolderTabControlDefinitionUnknownControl').stack,
            });
            return undefined;
    }
});
